module.exports = __webpack_public_path__ + "static/media/hedera-app.f716cdd4.png";